module.exports = __webpack_public_path__ + "static/img/icon_cluster.556cfb68.svg";